import { Skeleton } from '@/components/ui/skeleton'

const CARD_WIDTHS = ['w-11/12', 'w-4/5', 'w-10/12', 'w-3/4'] as const
const NODE_POSITIONS = [
  'left-[20%] top-[22%]', 'left-[33%] top-[18%]', 'left-[48%] top-[25%]',
  'left-[65%] top-[20%]', 'left-[73%] top-[34%]', 'left-[58%] top-[40%]',
  'left-[42%] top-[37%]', 'left-[27%] top-[43%]', 'left-[18%] top-[55%]',
  'left-[35%] top-[59%]', 'left-[51%] top-[53%]', 'left-[69%] top-[57%]',
  'left-[76%] top-[68%]', 'left-[61%] top-[73%]', 'left-[45%] top-[68%]',
  'left-[29%] top-[76%]', 'left-[23%] top-[67%]', 'left-[54%] top-[82%]',
] as const

export default function MemoryExplorerSkeleton({ label }: { label: string }) {
  return (
    <section
      role="status"
      aria-label={label}
      className="grid w-full overflow-hidden rounded-xl border border-border bg-card shadow-xs lg:h-full lg:min-h-0 lg:grid-cols-[minmax(0,1fr)_23rem] lg:grid-rows-[4rem_minmax(0,1fr)] xl:grid-cols-[minmax(0,1fr)_25rem] 2xl:grid-cols-[minmax(0,1fr)_30rem]"
    >
      <header className="flex h-16 items-center gap-3 border-b border-border px-5 lg:col-start-1 lg:row-start-1">
        <Skeleton className="size-9 shrink-0 rounded-lg" />
        <div className="min-w-0 flex-1 space-y-1.5">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-2.5 w-44 max-w-full" />
        </div>
        <div className="hidden items-center gap-7 sm:flex">
          {Array.from({ length: 3 }, (_, index) => (
            <div key={index} className="space-y-1.5">
              <Skeleton className="h-2.5 w-14" />
              <Skeleton className="h-4 w-12" />
            </div>
          ))}
        </div>
      </header>

      <div className="relative min-h-[560px] overflow-hidden bg-background lg:col-start-1 lg:row-start-2 lg:min-h-0">
        <Skeleton className="absolute left-[18%] top-[18%] h-[54%] w-[58%] rounded-full opacity-45" />
        <Skeleton className="absolute left-[29%] top-[29%] h-[32%] w-[36%] rounded-full opacity-70" />
        {NODE_POSITIONS.map((position, index) => (
          <Skeleton
            key={index}
            className={`absolute size-2.5 rounded-full ${position}`}
          />
        ))}
      </div>

      <aside className="h-[620px] border-t border-border p-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:h-full lg:min-h-0 lg:border-l lg:border-t-0">
        <Skeleton className="h-10 w-full rounded-lg" />
        <Skeleton className="mt-4 h-10 w-full rounded-lg" />
        <div className="mt-5 space-y-3">
          {Array.from({ length: 6 }, (_, index) => (
            <div key={index} className="space-y-2 rounded-lg border border-border p-3">
              <Skeleton className={`h-3.5 ${CARD_WIDTHS[index % CARD_WIDTHS.length]}`} />
              <Skeleton className="h-3 w-2/3" />
            </div>
          ))}
        </div>
      </aside>
    </section>
  )
}
